<template>
    <div class="mediaLibrary">
        <div class="wrapper">
            <div class="container">
                <h1>Media library</h1>
                <p class="text">We believe in a technologically advanced ecosystem where nature, technology and people coexist in harmony. Mission: Outstand from expected, bringing
                    a
                    new spirit to the industry, creating innovative products today for tomorrow. Vision: Be the company that inspires the world with the unimaginable. Our
                    philosophy;
                    the fusion between nature and technology. Maximise people’s experiences and natural emotions.</p>
                <div class="mediaLibrary__wrap">
                    <p class="title-wrap">Bike models</p>
                    <div class="media-item">
                        <input id="group-1" name="accordion" type="checkbox">
                        <label for="group-1" class="title-item"><span>Siryon Edition one - Polar lights</span></label>
                        <div class="mediaBox">
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-1"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-1"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-1"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-1"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-1"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-1"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-1"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-1"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                        </div>
                        <div class="link-wrap">
                            <a href="#" class="link">Copy link</a>
                            <a href="#" class="link">Download all (.zip, 45 Mb)</a>
                        </div>
                    </div>
                    <div class="media-item">
                        <input id="group-2" name="accordion" type="checkbox">
                        <label for="group-2" class="title-item"><span>Siryon Edition one - Polar lights</span></label>
                        <div class="mediaBox">
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-2"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-2"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-2"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-2"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-2"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-2"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-2"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-2"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                        </div>
                        <div class="link-wrap">
                            <a href="#" class="link">Copy link</a>
                            <a href="#" class="link">Download all (.zip, 45 Mb)</a>
                        </div>
                    </div>
                </div>
                <div class="mediaLibrary__wrap">
                    <p class="title-wrap">Forestal brand</p>
                    <div class="media-item">
                        <input id="group-3" name="accordion" type="checkbox">
                        <label for="group-3" class="title-item"><span>Logos</span></label>
                        <div class="mediaBox">
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-3"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-3"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-3"
                                   href="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                    <img src="/static/model_img/MsCj698T2rDoFFtxD97VMlLZYfDggnCK9ceT6snA.png">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery-3"
                                   href="/assets/pdf/dummy.pdf">
                                    <img src="/assets/images/icons/pdf.svg">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                        </div>
                        <div class="link-wrap">
                            <a href="#" class="link">Copy link</a>
                            <a href="#" class="link">Download all (.zip, 45 Mb)</a>
                        </div>
                    </div>
                </div>
                <div class="mediaLibrary__wrap cover">
                    <p class="title-wrap">Riders</p>
                    <div class="media-item">
                        <input id="group-4" type="checkbox">
                        <label for="group-4" class="title-item"><span>Cedric Gracia</span></label>
                        <div class="mediaBox">
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery" href="/static/media_blocks/FTC.jpg">
                                    <img src="/static/media_blocks/FTC.jpg">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery"
                                   href="/static/news_img/7UjtwgpX9FToQMO248qasT1AfuX2XrhMBeYTD4Yu.jpeg">
                                    <img src="/static/news_img/7UjtwgpX9FToQMO248qasT1AfuX2XrhMBeYTD4Yu.jpeg">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery"
                                   href="/static/news_img/7UjtwgpX9FToQMO248qasT1AfuX2XrhMBeYTD4Yu.jpeg">
                                    <img src="/static/news_img/7UjtwgpX9FToQMO248qasT1AfuX2XrhMBeYTD4Yu.jpeg">
                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                            <div class="item">
                                <a class="img-wrap" data-fancybox="gallery" href="/assets/images/icons/test.MP4">
                                    <img src="/assets/images/icons/test.jpg">
                                    <span class="time-video">0:49</span>

                                </a>
                                <p class="img-name">bike.png</p>
                            </div>
                        </div>
                        <div class="link-wrap">
                            <a href="#" class="link">Copy link</a>
                            <a href="#" class="link">Download all (.zip, 45 Mb)</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        name: "mediaLibrary",
        props: ['lang', 'trans'],
        mounted() {


        },
    }

</script>
